import type { TabBarScrollState } from "web_myplann/Shared/Types/TabBarScrollState";

const DIRECTION_THRESHOLD = 4;
const TOP_ZONE = 24;

export const getTabBarScrollState = (
	{ collapsed, anchor }: TabBarScrollState,
	scrollTop: number,
): TabBarScrollState => {
	if (scrollTop < TOP_ZONE) {
		return { collapsed: false, anchor: scrollTop };
	}
	const delta = scrollTop - anchor;
	if (collapsed ? delta > 0 : delta < 0) {
		return { collapsed, anchor: scrollTop };
	}
	if (Math.abs(delta) > DIRECTION_THRESHOLD) {
		return { collapsed: !collapsed, anchor: scrollTop };
	}
	return { collapsed, anchor };
};
